// Language-dependent UI copy (chrome, labels, messages) — English version.
// German version: src/data/modules/ui.ts (identical structure).
const uiData = {
  languageSwitch: {
    label: "Language",
    de: "DE",
    en: "EN",
    switchTo: "Zur deutschen Version wechseln"
  },
  workDetail: {
    challenge: "Challenge",
    solution: "Solution",
    implementation: "Implementation",
    results: "Results",
    technologies: "Technologies Used",
    standardLibraries: "Standard Building Blocks",
    codeExamples: "Code Examples",
    backToOverview: "Back to Overview",
    gallery: "Insights",
    demoVideo: "Watch the Video",
    project: "Project",
    links: "Links",
    date: "Date",
    platforms: "Platforms",
    prevCase: "Previous Project",
    nextCase: "Next Project",
    copyCode: "Copy code",
    codeCopied: "Copied!",
    learnMoreAbout: "Learn more about {title}",
    appStoreDownload: "Download on the App Store",
    showCode: "Show code",
    example: "Example",
    startProject: "Start a project",
    openOnGitHub: "Open {name} on GitHub"
  },
  contact: {
    quickResponseTitle: "Need a quick response?",
    quickResponseText: "Use the form and I will get back to you as soon as possible.",
    thankYouTitle: "Thank you for your interest",
    successTitle: "Thank you for your message!",
    successText: "I will get back to you as soon as possible.",
    sending: "Sending…",
    errorGeneric: "Something went wrong while sending. Please try again later.",
    errorValidation: "Please check your input and try again.",
    newFormButton: "New form",
    requiredField: "* Required field",
    socialTitle: "You can also find me on",
    thankYouText: "I look forward to exciting new projects and challenges!"
  },
  notFound: {
    title: "Page Not Found",
    text: "The requested page does not exist or has been moved.",
    backHome: "Back to Home",
    funFact: "Fun fact: the first 404 error message was invented at CERN, when researchers couldn't find room 404. Luckily you don't have to search that far! 😉"
  },
  nav: {
    menu: "Menu",
    open: "Open menu",
    close: "Close menu"
  },
  blog: {
    readMore: "Read more",
    backToOverview: "Back to the blog",
    readingTime: "{min} min read"
  },
  comments: {
    title: "Comments",
    empty: "No comments yet. Go ahead and start.",
    loginPrompt: "Sign in real quick to join the conversation:",
    loginGoogle: "Sign in with Google",
    loginApple: "Sign in with Apple",
    signedInAs: "Signed in as",
    signOut: "Sign out",
    placeholder: "What do you think?",
    submit: "Post comment",
    sending: "Sending…",
    reply: "Reply",
    cancel: "Cancel",
    pendingBadge: "Awaiting approval",
    pendingNotice: "Thanks! Your comment is in and will show up after a quick review.",
    errorGeneric: "That didn't work just now. Please try again later.",
    errorRateLimited: "More than five comments per hour won't go through. Take a breather.",
    errorInvalid: "The comment is empty, too long, or has too many links."
  },
  footer: {
    imprint: "Imprint",
    privacy: "Privacy Policy"
  },
  cv: {
    technicalSkills: "Technical Skills",
    languages: "Languages",
    interests: "Interests",
    profile: "Profile",
    experience: "Professional Experience",
    tasks: "Responsibilities:",
    clients: "Clients:",
    emailLabel: "Email",
    phoneLabel: "Phone",
    addressLabel: "Address",
    skillsTech: "Technologies",
    skillsLangs: "Languages",
    skillsConcepts: "Concepts"
  },
  about: {
    badge: "About me",
    activityHeatmapAlt: "{name} activity heatmap",
    activityProfileAria: "Open {name} profile"
  },
  home: {
    brandGroupAria: "Brand group {n}"
  },
  media: {
    previewNotAvailable: "Preview not available",
    play: "Play video",
    close: "Close",
    deferredLoading: "Loads later",
    videoUnsupported: "Your browser does not support the video element."
  },
  dateLocale: "en-US"
};

export default uiData;
export type UiData = typeof uiData;
